<!-- 
  // As máscaras do campo de texto ainda usam o padrão antigo com 99 ao invés do maskonha com 00

  <KInputMasked
    v-model="phone"
    label="Telefone"
    mask="(99) 9 9999-9999"
    validate-mask
    return-masked
    @finished="onFinished"
  />

  <KInputMasked
    v-model="cnpj"
    label="CNPJ"
    mask="AA.AAA.AAA/9999-99"
    validate-mask
    return-masked
    @finished="onFinished"
  />
 -->

<template>
  <v-text-field v-bind="$attrs" v-model="model" :inputmode="isNumericMask ? 'numeric' : 'text'" :maxLength="maxLength"
    :rules="applyRules" />
</template>

<script>
import { Maskonha } from '../../plugins/maskonha/maskonha';
import { isNumeric } from 'klawtil';

export default {
  name: "k-input-masked",

  props: {
    value: String,
    mask: [String, /*Array*/],
    rules: { type: Array, default: () => [] },
    // Define se o valor deve ser retornado com a máscara
    returnMasked: Boolean,
    // Define se deve-se validar se o valor está batendo com a máscara
    validateMask: Boolean
  },

  data() {
    return {
      model: null
    };
  },

  watch: {
    value(newVal, oldVal) {
      this.model = this.applyMask(newVal);
    },
    model(value, oldValue) {
      this.$emit("input", this.emitInput);
      this.model = this.maskedValue;

      //
      if (this.maskedValue && this.maskedValue.length === this.maxLength) {
        this.$emit("finished", this.emitInput);
      }
    }
  },

  computed: {
    /**
     * Verifica se o a máscara é numérica
     */
    isNumericMask() {
      return isNumeric(Maskonha.unmask(this.mask))
    },

    /**
     * Gera o valor com máscara
     */
    maskedValue() {
      if (this.model) {
        return this.applyMask(this.model);
      }
      return null;
    },

    /**
     * Gera o valor sem máscara
     */
    unMaskedValue() {
      if (this.model) return Maskonha.unmask(this.model);
      return null;
    },

    /**
     * Verifica se deve usar ou não a máscara e retorna o valor correto
     */
    emitInput() {
      if (this.returnMasked) return this.maskedValue;
      return this.unMaskedValue;
    },

    /**
     * Verifica se o valor com a máscara é válido
     */
    isValid() {
      if (this.maskedValue) {
        if (typeof this.mask === "string") {
          return this.maskedValue.length === this.maxLength;
        // } else if (Array.isArray(this.mask)) {
        //   return this.mask.some(
        //     mask => mask.length === this.maskedValue.length
        //   );
        }
      }

      return false;
    },

    /**
     * Aplica as regras vindas de validação do formulário e mescla com as regras definidas
     * no componente, desde que seja definido o atributo validateMask
     */
    applyRules() {
      const rules = this.rules;

      if (this.validateMask) {
        // Valida se o valor está no formato da máscara. Se estiver vazio, pula
        const isValid = () =>
          !this.model || this.isValid
            ? true
            : "Formato " + JSON.stringify(this.mask);
        rules.push(isValid);
      }

      return rules;
    },

    /**
     *
     */

    /**
     * Calcula o tamanho máximo do campo de texto
     */
    maxLength() {
      if (this.mask) {
        // Se for string, retorne-o
        if (typeof this.mask === "string") return this.mask.length;
        // Se for array, verifique o maior
        else if (Array.isArray(this.mask)) {
          return this.mask.reduce(
            (last, curr) => (curr.length > last ? curr.length : last),
            0
          );
        }
      }

      return "";
    }
  },

  methods: {
    /**
     * Aplica uma máscara
     */
    applyMask(value) {
      if (value) return Maskonha.mask(value, this.mask, { number: '9' });
      return null;
    },
  },

  mounted() {
    //
    if (this.value) this.model = this.value;
    else this.model = null;
  }
};
</script>

<style></style>
